/** Browser login handoff for the NitroMule desktop app. */

const DESKTOP_AUTH_STORAGE_KEY = 'nm_desktop_auth';
export const DESKTOP_BROWSER_AUTH_LOGIN_PATH = '/auth/desktop/login';

function normalizePathname(pathname) {
  return String(pathname || '/').replace(/\/$/, '') || '/';
}

export function isDesktopBrowserAuthRoute(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  const path = normalizePathname(pathname);
  if (path === DESKTOP_BROWSER_AUTH_LOGIN_PATH) return true;
  if (typeof window === 'undefined') return false;
  if (path === '/login' && new URLSearchParams(window.location.search).get('client') === 'desktop') {
    return true;
  }
  return false;
}

export function captureDesktopAuthParamsFromUrl() {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get('client') === 'desktop';
  const fromRoute = isDesktopBrowserAuthRoute();
  if (!fromQuery && !fromRoute) return null;
  const payload = {
    client: 'desktop',
    state: String(params.get('state') || '').trim(),
  };
  try {
    sessionStorage.setItem(DESKTOP_AUTH_STORAGE_KEY, JSON.stringify(payload));
  } catch (_) {}
  return payload;
}

export function getDesktopAuthPayload() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(DESKTOP_AUTH_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.client !== 'desktop') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearDesktopAuthPayload() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(DESKTOP_AUTH_STORAGE_KEY);
  } catch (_) {}
}

export function getDesktopAuthRequestBody() {
  const payload = getDesktopAuthPayload();
  if (!payload) return {};
  return {
    client: 'desktop',
    desktop_state: payload.state || '',
  };
}

export async function maybeCompleteDesktopAuthAfterLogin(data) {
  const payload = getDesktopAuthPayload();
  const redirect = data?.desktop_redirect;
  if (!payload || !redirect) return false;
  clearDesktopAuthPayload();
  window.location.assign(String(redirect));
  return true;
}

export function shouldUseDesktopBrowserLogin() {
  if (typeof window === 'undefined') return false;
  if (window.nitromuleDesktop?.isDesktopApp) return true;
  return isDesktopBrowserAuthRoute() || getDesktopAuthPayload()?.client === 'desktop';
}

/** Desktop browser sign-in is isolated from an existing nitromule.com browser session. */
export function shouldIsolateDesktopBrowserAuthSession(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  return isDesktopBrowserAuthRoute(pathname);
}

export function applyDesktopBrowserAuthSessionIsolation(config) {
  if (!shouldIsolateDesktopBrowserAuthSession()) return config;
  return {
    ...config,
    userLoggedIn: false,
    token: '',
    userId: null,
    userEmail: '',
    userDisplayName: '',
    isAdmin: false,
    isTrustedCustomer: false,
    userRole: 'standard',
  };
}

export function shouldPersistBrowserSessionAfterAuth(data) {
  if (data?.desktop_redirect) return false;
  if (getDesktopAuthPayload()) return false;
  return true;
}
